import React, { useState, useEffect } from "react";
import "./CategoryList.css";
import CategoryHeader from "../Category/CategoryHeader/CategoryHeader";
import { FaEdit, FaTrash } from "react-icons/fa";
import CategoryListHeader from "./CategoryListHeader";
import img from "../../Component/Header/logo.png";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import DeletePopup from "../../Component/DeletePopup/DeletePopup";
import EditCategoryOverlay from "./EditCategoryOverlay/EditCategoryOverlay";
import Spinner from "../../Component/Spinner/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import ConfirmPopup from "../../Component/ConfirmPopup/ConfirmPopup";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import { APP_VERSION } from "../Version Provider/VersionConfig";
const columnToApiMap = {
    categoryName: "CategoryName",
    description: "Description",
    status: "Status",
    companyName: "CompName",
    createdBy: "CreatedByAdminName",
    lastUpdated: "LastUpdate",
    createdAt: "LastUpdate",
};

const CategoryList = () => {
    const [globalSearch, setGlobalSearch] = useState("");
    const [columnSearch, setColumnSearch] = useState({
        categoryName: "",
        description: "",
        companyName: "",
        createdBy: "",
        status: "Active",
        lastUpdated: "",
    });
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);

    // Delete states
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // Edit states
    const [showEditModal, setShowEditModal] = useState(false);
    const [editCategory, setEditCategory] = useState(null);

    //version control state
    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success",
    });
    const navigate = useNavigate();
    const limit = 20;
    const [sortState, setSortState] = useState({
        column: "lastUpdated",
        order: "desc",
    });

    const fetchCategories = async (pageNum = 1) => {
        setLoading(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const startfrom = (pageNum - 1) * limit;
            const apiSortColumn =
                columnToApiMap[sortState.column] || "LastUpdate";
            const apiSortOrder = sortState.order === "asc" ? 1 : -1;
            console.log("Sorting by:", apiSortColumn, apiSortOrder);
            const payload = {
                VersionCode: versionCode,
                startfrom,
                limit,
                categoryName: columnSearch.categoryName || "",
                description: columnSearch.description || "",
                categoryImagePath: "",
                companyName: columnSearch.companyName || "",
                createdBy: columnSearch.createdBy || "",
                status: columnSearch.status || "",
                lastUpdateStartDate: columnSearch.startDate
                    ? formatIndianDate(new Date(columnSearch.startDate))
                    : "",
                lastUpdateEndDate: columnSearch.endDate
                    ? formatIndianDate(new Date(columnSearch.endDate))
                    : "",
                searchstring: globalSearch || "",
                SortColumn: apiSortColumn,
                SortOrder: apiSortOrder,
            };

            const res = await axios.post(Api.getCategories, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (
                res.data.status === 0 &&
                res.data.message &&
                res.data.message.toLowerCase().includes("version")
            ) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {res.data.message}
                        </>
                    ),
                    type: "error",
                });
                return;
            }
            if (res.data.status === 1 && Array.isArray(res.data.data)) {
                let categories = res.data.data.map((item) => ({
                    _id: item._id,
                    categoryName: item.CategoryName || "",
                    description: item.Description || "",
                    image: item.CategoryImagePath
                        ? `${Api.baseurl.replace(
                              /\/$/,
                              "",
                          )}/${item.CategoryImagePath.replace(/^\//, "")}`
                        : img,

                    status: item.Status || "Deactive",
                    companyName: item.CompName || "N/A",
                    createdBy: item.CreatedByAdminName || "Admin",
                    lastUpdated: item.LastUpdate
                        ? formatIndianDate(item.LastUpdate)
                        : "-",
                    originalCategory: item,
                }));

                categories = categories.map((item, index) => ({
                    ...item,
                    id: startfrom + index + 1,
                }));

                setData(pageNum === 1 ? categories : [...data, ...categories]);

                if (categories.length < limit) {
                    setHasMore(false);
                }
            } else {
                if (
                    res.data.status === 0 &&
                    (res.data.message === "Invalid AuthToken" ||
                        res.data.message === "AuthToken is required")
                ) {
                    localStorage.removeItem("authToken");
                    localStorage.removeItem("currentUser");
                    navigate("/");
                }
                setHasMore(false);
            }
        } catch (err) {
            console.error("Error fetching categories:", err);
            setPopup({
                show: true,
                message:
                    err.response?.data?.message ||
                    "Failed to fetch categories.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };
    const handleSortChange = (column, order) => {
        setSortState({ column, order });
        setData([]);
        setPage(1);
        setHasMore(true);
    };

    useEffect(() => {
        setLoading(true);

        setData([]);
        setPage(1);
        setHasMore(true);

        const handler = setTimeout(() => {
            fetchCategories(1).finally(() => {
                setLoading(false);
            });
        }, 300);

        return () => clearTimeout(handler);
    }, [globalSearch, columnSearch, sortState]);

    const fetchMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchCategories(nextPage);
    };

    // Edit
    const handleEditClick = (row) => {
        setEditCategory(row);
        setShowEditModal(true);
    };

    // Delete
    const handleDeleteClick = (id) => {
        setSelectedId(id);
        setShowDeleteModal(true);
    };

    // Confirm delete
    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const categoryToUpdate = data.find(
                (item) => item._id === selectedId,
            );

            if (!categoryToUpdate) {
                setPopup({
                    show: true,
                    message: "Category not found",
                    type: "error",
                });
                return;
            }

            const res = await axios.post(
                Api.editCategory,
                {
                    _id: selectedId,
                    CategoryName: categoryToUpdate.categoryName,
                    Description: categoryToUpdate.description,
                    Status: "Deactive",
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (res.data.status === 1) {
                setPopup({
                    show: true,
                    message:
                        res.data.message ||
                        "Category deactivated successfully!",
                    type: "success",
                });

                setShowDeleteModal(false);
                setSelectedId(null);
                setData([]);
                setPage(1);
                setHasMore(true);
                fetchCategories(1);
            } else {
                setPopup({
                    show: true,
                    message:
                        res.data.message ||
                        "Failed deactivating category. Please try again.",
                    type: "error",
                });
            }
        } catch (err) {
            console.error("Error deactivating category:", err);
            setPopup({
                show: true,
                message:
                    err.response?.data?.message ||
                    "Error deactivating category",
                type: "error",
            });
        } finally {
            setShowDeleteModal(false);
            setSelectedId(null);
        }
    };
    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    return (
        <div className="category-table-container">
            <CategoryHeader
                search={globalSearch}
                setSearch={setGlobalSearch}
                columnSearch={columnSearch}
                setColumnSearch={setColumnSearch}
                onRefresh={() => {
                    setSortState({ column: "lastUpdated", order: "desc" });
                    setData([]);
                    setPage(1);
                    setHasMore(true);
                }}
            />

            <div className="category-grid-table" id="scrollableDiv">
                <CategoryListHeader
                    columnSearch={columnSearch}
                    setColumnSearch={setColumnSearch}
                    currentSortColumn={sortState.column}
                    currentSortOrder={sortState.order}
                    onSortChange={handleSortChange}
                />

                {loading && page === 1 ? (
                    <Spinner />
                ) : data.length > 0 ? (
                    <InfiniteScroll
                        dataLength={data.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<Spinner />}
                        endMessage={
                            <div className="no-data">No more categories</div>
                        }
                        scrollableTarget="scrollableDiv"
                        style={{ overflow: "visible" }}
                    >
                        {data.map((row, index) => (
                            // Add console.log here
                            //console.log("Row Image URL:", row.image),
                            <div className="category-grid-row" key={row._id}>
                                <div>{index + 1}</div>
                                <div className="category-action-icons">
                                    <button
                                        className="edit"
                                        onClick={() => handleEditClick(row)}
                                    >
                                        <FaEdit />
                                    </button>
                                    <button
                                        className="delete"
                                        onClick={() =>
                                            handleDeleteClick(row._id)
                                        }
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                                <div>
                                    {row.image ? (
                                        <img
                                            src={row.image}
                                            alt={row.categoryName}
                                            className="category-img"
                                            onError={(e) => {
                                                console.error(
                                                    "Image load failed for:",
                                                    row.image,
                                                );
                                                e.target.src = img;
                                            }}
                                        />
                                    ) : (
                                        <div className="no-image-placeholder">
                                            No Image
                                        </div>
                                    )}
                                </div>
                                <div>{row.categoryName}</div>
                                <div>{row.description}</div>
                                <div className={`status-badge-category ${row.status === "Active" ? "active" : "deactive"}`}
                                >
                                    {row.status === "Active" ? "Active" : "Deactive"}
                                </div>
                                <div>{row.companyName}</div>
                                <div>{row.createdBy}</div>
                                <div>{row.lastUpdated}</div>
                            </div>
                        ))}
                    </InfiniteScroll>
                ) : (
                    <div className="no-data">
                        {loading
                            ? "Searching categories..."
                            : "No categories found"}
                    </div>
                )}
            </div>

            {showEditModal && editCategory && (
                <EditCategoryOverlay
                    category={editCategory}
                    onClose={() => setShowEditModal(false)}
                    onSave={() => {
                        setShowEditModal(false);
                        setData([]);
                        setPage(1);
                        setHasMore(true);
                        fetchCategories(1);
                    }}
                />
            )}

            <DeletePopup
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={confirmDelete}
            />

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default CategoryList;
